export function Stub({ title }: { title: string }) {
  return (
    <div className="p-9">
      <h1 className="text-[28px] font-display font-bold tracking-tight">{title}</h1>
      <p className="mt-2 text-ink-60">Скоро здесь будет рабочий экран.</p>
    </div>
  );
}
